import axios from "axios";

import { successHandling } from "../helpers/successHandling";
import {
  currentDateInUTC,
  scheduledDateInUTC
} from "../helpers/datetimeHandlers";
import { apiSelectedGroupsHandler } from "../helpers/apiSelectedIdsHandler";

export const rotationAPI = async (
  device_id,
  devices,
  selectedGroups,
  executeType,
  datetime,
  orientation,
  t,
  successfulText
) => {
  let formData = new FormData();
  formData.append("device_id", device_id); // single device
  apiSelectedGroupsHandler(formData, devices, selectedGroups); // multiple devices
  formData.append("execute_type", executeType);
  formData.append(
    "execute_datetime",
    datetime === "immediately"
      ? currentDateInUTC()
      : scheduledDateInUTC(datetime)
  );
  formData.append("rotation_type", orientation);

  await axios({
    url: `/api/v2/command/screen-rotation-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};
